import { PATH_WORKSHOP_AND_EVENTS_NEW } from '@configs'
import { Card } from 'antd'
import { useNavigate } from 'react-router-dom'
import ListWorkshopEventTable from './ListWorkshopEventTable'

type Props = { activeTab?: string }
export const WorkShopEvent = ({ activeTab }: Props) => {
  const navigate = useNavigate()
  return (
    <>
      <Card>
        <ListWorkshopEventTable
          onAddNew={() => navigate(PATH_WORKSHOP_AND_EVENTS_NEW)}
        />
      </Card>
    </>
  )
}
